<template>
  <PrimeDatePicker
    :model-value="internalDate"
    view="month"
    dateFormat="MM"
    :disabled="disabled"
    :placeholder="placeholder"
    :input-id="id"
    showIcon
    @update:modelValue="handleDateChange"
  />
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    placeholder?: string;
  }>(),
  {
    disabled: false,
    loading: false,
  }
);

const value = defineModel<number | null>("value");

// Intermediary ref to handle Date <-> Year conversion
const internalDate = ref<Date | null>(null);

// Watch value changes (year -> date)
watch(
  () => value.value,
  (newMonth) => {
    if (newMonth && typeof newMonth === "number") {
      // Convert month to Date (1st day of that month)
      internalDate.value = new Date(2000, newMonth - 1, 1);
    } else {
      internalDate.value = null;
    }
  },
  { immediate: true }
);

// Handle date picker changes (date -> year)
function handleDateChange(
  date: Date | Date[] | (Date | null)[] | null | undefined
) {
  internalDate.value = date as Date | null;
  if (date instanceof Date) {
    value.value = date.getMonth() + 1;
  } else {
    value.value = null;
  }
}

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();
</script>

<style scoped></style>
